import { GROUPLIST_SEARCH, GROUPLIST_PAGE } from '../actions/grouplistactions';

const state = { search:'', page:0 };

const getters = {
    page: state => state.page,
    search: state => state.search
};

const actions = {
    [GROUPLIST_SEARCH]: ({ commit }, search) => {
        commit(GROUPLIST_SEARCH, search);
    },
    [GROUPLIST_PAGE]: ({ commit }, page) => {
        commit(GROUPLIST_PAGE, page);
    }
};

const mutations = {
    [GROUPLIST_SEARCH]: (state, search) => {
        state.page = 0;
        state.search = search;
    },
    [GROUPLIST_PAGE]: (state, page) => {
        state.page = page;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};